import { SET_CLASSROOMS, SET_CLASSROOM, SET_CLASSROOM_NAME, RESET } from './actionTypes'
import { hangup } from '../otuVision/actions'

export function reset() {
  return { 
    type : RESET
  }
}

export function getClassrooms() {
  return (dispatch, getState) => {
    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classrooms.getClassrooms',{},{
      responseType : 'json',
      noSysInteraction : true, 
      callback : function ( classrooms ) {
        
        dispatch( {
          type : SET_CLASSROOMS,
          classrooms 
        } )
        dispatch ( setClassroom() )
      }
      } )
    }
}

export function setClassroom( classroom = null ) {
  return (dispatch, getState) => {
    
    const state = getState();

    const currentClassroomId = state.classrooms.classroom.id 

    if ( !state.classrooms.classrooms[currentClassroomId] || ( currentClassroomId === null && classroom === null && state.classrooms.classroomsSorted.length ) ) {
      const classroomId = otuApp.appState.classroomId
      if ( classroomId ) { 
        classroom = state.classrooms.classrooms[classroomId]
      } else {
        classroom = state.classrooms.classroomsSorted[0]
      }
    } 

    if ( classroom ) dispatch({
      type : SET_CLASSROOM,
      classroom
    })

    if (classroom && state.otuVision.onCall && currentClassroomId != state.classrooms.classroom.id ) {
      // hangup otuVision
      dispatch( hangup() )

    }
    

  }
}

export function showClassroomsList( options = {} ){

  return (dispatch, getState) => {
    const url="index.php?component=com_otu_op&task=goToStep&step=876";
    otuApp.triggerAjaxGet(url,{
      "attr":{"data-hide-template-position":"columns-all"},
      callback : () => {
        if (options.history) {
            otuApp.pageNavigation.setHistory({history : options.history})

        }
      }
    });	    
  }

}

export function showClassroomCreate( options = {} ){

  return (dispatch, getState) => {
    const url="index.php?component=com_otu_op&task=goToStep&step=877";
    otuApp.triggerAjaxGet(url,{"attr":{"data-hide-template-position":"columns-all"}});	    
  }

}


export function showClassroomManage( options = {} ){

  const history = otuApp.pageNavigation.history();

  return (dispatch, getState) => {
    const url="index.php?component=com_otu_op&task=goToStep&step=878&missionId=" + options.missionId;
    otuApp.triggerAjaxGet(url,{"attr":{"data-hide-template-position":"columns-all"},
      callback: ()=>{ otuApp.pageNavigation.setHistory({history})}
    });	    
  }

}

export function showSignUpStudents ( options = {}){
  
  return (dispatch, getState) => {
    const url="index.php?component=com_otu_op&task=goToStep&step=806";
    otuApp.triggerAjaxGet(url,{"attr":{"data-hide-template-position":"columns-all"}});	   
  }
  
}

export function setClassroomName ( options = {} ) {
  
  return (dispatch, getState) => {

    dispatch( { 
        type : SET_CLASSROOM_NAME, 
        classroom : options.classroom,
        name : options.name

      } 
    )
    
    if ( options.name.length>1) dispatch( saveClassroom( options.classroom ) )
  
  }

}

export function saveClassroom ( classroom ) {

  return ( dispatch, getState ) => {

    const data = {
      classroomId : classroom.id,
      name : classroom.name
    }

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classrooms.saveClassroom',data,{
      responseType : 'json',
      noSysInteraction : true, 
      callback : function ( classroom ) {
          
      }
      } )

    }

}

export function createClassroom ( classroom ) {
  return ( dispatch, getState ) => {

    const data = {
      name : classroom.name,
      challengeDuration : classroom.challengeDuration,
      challengeChoosen : classroom.challengeChoosen
    }

    const history = otuApp.pageNavigation.history();

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classrooms.createClassroom',data,{
      responseType : 'json',
      callback : function ( classroom ) {
        //dispatch(setClassroom(classroom));

        dispatch(showClassroomsList({ history }));

        //dispatch(showClassroomManage({missionId:classroom.missionId}))
      
      }
      } )

    }
}

export function deleteClassroom ( classroom ) {
  return ( dispatch, getState ) => {

    const data = {
      classroomId : classroom.id
    }

    const history = otuApp.pageNavigation.history();

    otuApp.triggerAjaxPost( otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=classrooms.deleteClassroom',data,{
      responseType : 'json',
      callback : function ( data ) {
        dispatch(showClassroomsList({history}))
      }
      } )

    }
}
